import { Steps } from 'antd';

const CustomSteps = (props) => <Steps {...props} />;
export default CustomSteps;
